import React from 'react';
import { Box, Paper, Typography, IconButton, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { formatDateTimeLocal } from '../../common/DateUtil';

const AppointmentTile = ({ appointment, onEdit, t }) => {
    const { startAt, endAt, serviceName } = appointment;

    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }} data-testid={`appointment-tile-${serviceName}`}>
            <Grid
                container
                alignItems="center"
                spacing={2}
            >
                {/* Appointment Info */}
                <Grid item xs={10}>
                    <Box>
                        <Typography variant="body2" fontWeight={600} data-testid="appointment-service-name">
                            {serviceName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" data-testid="appointment-time">
                            {formatDateTimeLocal(startAt)} {endAt ? ` - ${formatDateTimeLocal(endAt).split(' ')[1]}` : ''}
                        </Typography>
                    </Box>
                </Grid>

                {/* Actions */}
                {onEdit && (
                    <Grid item xs={2} sx={{ textAlign: 'right' }}>
                        <IconButton size="small" onClick={() => onEdit(appointment)} data-testid="edit-appointment-icon-button">
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
};

export default AppointmentTile;
